import { render, staticRenderFns } from "./tab-pane.vue?vue&type=template&id=a714c99c&"
import script from "./tab-pane.vue?vue&type=script&lang=js&"
export * from "./tab-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports